<template>
    <v-select
        v-model="selectedHardwareVersion"
        :label="$t('HardwareSelector.label')"
        :items="hardwareOptions"
        item-text="text"
        item-value="value"
        filled
        color="primary"
        :dense="dense"
        hide-details="auto"
        :disabled="disabled"
        :placeholder="$t('HardwareSelector.placeholder')"
    >
        <template v-slot:append>
            <v-icon>{{ disabled ? "" : "mdi-chevron-down" }}</v-icon>
        </template>
    </v-select>
</template>

<script>
import formatHardwareLabel from '@/utils/formatHardwareLabel.js'

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        local: {
            type: Boolean,
            default: false
        },
        value: {
            default: null
        }
    },
    computed: {
        hardwareOptions() {
            const hardware = this.$store.getters.hardware
            if (!hardware) {
                return []
            }
            return Object.entries(hardware)
                .filter(([name]) => !name.endsWith('_endianswap'))
                .map(([name, value]) => ({
                    text: formatHardwareLabel(name),
                    value
                }))
                .sort((a, b) => a.text.localeCompare(b.text))
        },
        selectedHardwareVersion: {
            get() {
                return this.local ? this.value : this.$store.getters.selectedHardwareVersion
            },
            set(value) {
                if (this.local) {
                    this.$emit('input', value)
                    return
                }
                this.$store.dispatch('setSelectedHardwareVersion', value)
            }
        }
    }
}

</script>
